import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './AppSidebar.css';

function AppSidebar({ isOpen, onClose }) {
  const location = useLocation();

  const navItems = [
    { path: '/app/focus', label: 'Focus', icon: '⏱️', description: 'Main timer view' },
    { path: '/app/flashes', label: 'Micro resets', icon: '🧘', description: 'Desk stretches and breathing breaks' },
    { path: '/app/goals', label: 'Goals', icon: '🎯', description: 'Goal setting' },
    { path: '/app/analytics', label: 'Analytics', icon: '📊', description: 'Time tracking' },
    { path: '/app/community', label: 'Community', icon: '👥', description: 'Social features' },
    { path: '/app/fiona', label: 'Focus Fiona', icon: '🤖', description: 'AI Coach' },
    { path: '/app/settings', label: 'Settings', icon: '⚙️', description: 'Preferences' }
  ];

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div className="sidebar-overlay" onClick={onClose} aria-hidden="true" />
      )}
      
      <aside className={`app-sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <h1 className="sidebar-logo">Within</h1>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 
                `sidebar-nav-item ${isActive || (item.path === '/app/focus' && location.pathname === '/app') ? 'nav-item-active' : ''}`
              }
              onClick={onClose}
              title={item.description}
            >
              <span className="nav-item-icon" role="img" aria-label={item.label}>
                {item.icon}
              </span>
              <span className="nav-item-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <p className="sidebar-footer-text">
            Focus with intention
          </p>
        </div>
      </aside>
    </>
  );
}

export default AppSidebar;
